import {
  Button,
} from "antd";
import React, {
  forwardRef,
  useEffect,
  useState,
  useRef,
} from "react";
import {
  MenuOutlined,
  HistoryOutlined
} from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import { useLocation } from 'react-router-dom';
import commonFn from "@/utils/commonFn";
import { CustomTable, CustomTableExtend } from "@/hocComponents";

const MainTable = forwardRef((props, ref) => {
  const location = useLocation();
  const [periodList, setPeriodList] = useState([]);

  const initTableHead = {
    vendorName: null,
    role: null,
    payAmount: null,
    jobCount: null,
    payPeriod: null,
    perJobCost: null,
  }
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = 'Input') => {
    commonFn.tableFilterFn({event, key, type, setTableHead, getTableListFn})
  }

  const initColumns = [
    {
      title: '#',
      dataIndex: '#',
      width: 50,
    },
    {
      title: "Vendor Name",
      dataIndex: "vendorName",
      titleType: "Input",
      width: 100,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "vendorName"),
    },
    {
      title: "Role",
      dataIndex: "role",
      titleType: "Input",
      width: 100,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "role"),
    },
    {
      title: "Pay Amount",
      dataIndex: "payAmount",
      titleType: "Input",
      width: 100,
      isSorter: true,
      sortterMultiple: 3,
      isAmountFlag: true,
      onChange: (e) => tableFilterFn(e, "payAmount"),
    },
    {
      title: "Pay Period",
      dataIndex: "payPeriod",
      titleType: "Select",
      width: 100,
      isSorter: true,
      sortterMultiple: 3,
      selectOptions: periodList,
      onChange: (value) => tableFilterFn(value, "payPeriod", "Select"),
    },
    {
      title: "Job Count",
      dataIndex: "jobCount",
      titleType: "Input",
      width: 100,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "jobCount"),
    },
    {
      title: "Per Job Cost",
      dataIndex: "perJobCost",
      titleType: "Input",
      width: 100,
      isSorter: true,
      sortterMultiple: 3,
      isAmountFlag: true,
      onChange: (e) => tableFilterFn(e, "perJobCost"),
    },
    {
      title: 'Click to View',
      dataIndex: "viewDetail",
      titleType: "",
      width: 60, 
      render: (text, record) => (
        <Button
          type="link"
          onClick={() => handleDetailClick(record)}
          style={{ color: '#1890ff'}}
        >
          View
        </Button>
      ),
    },
  ]

  const handleDetailClick = (record) => {
    const params = { 
      email: new URLSearchParams(location.search).get("email"),
      batch: new URLSearchParams(location.search).get("batch"),
      monthlyWorkerPayId: record.id
    };
    const route = "/AccountPayable/CheckApprovalMonthlyWorkerSubDetail"
    const url = `${window.location.origin}#${route}?${new URLSearchParams(params).toString()}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };
  
  const [columns, setColumns] = useState(initColumns);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });

  //列表
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      ...tableHead,
      usid: new URLSearchParams(location.search).get("email"),
      type: new URLSearchParams(location.search).get("module"),
      batch: new URLSearchParams(location.search).get("batch"),
    };
    const response = await http.get(api.checkShowMonthlyWorkerDetail, { params });
    if (response?.code !== "1") {
      commonFn.modalFailedFn(response)
      setTableLoading(false);
      return
    }
    const list = (response.data.list || []).map((item, index) => ({ ...item, '#': (params.page - 1) * params.count + index + 1}));
    setTableList(list);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
    setTableLoading(false);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  const getDictionaryFn = async(value) => {
    const response = await http.get(api.getPeriodList);
    setPeriodList((response?.data || [])?.map(item => ({
      label: item,
      value: item,
    })))
  }

  const initColunmsFn = () => {
    setTableHead(initTableHead);
    setColumns(initColumns);
  }
    
  useEffect(() => {
    getDictionaryFn()
  }, [])

  useEffect(() => {
    if(periodList?.length){
      setColumns(initColumns);
    }
  }, [periodList]);


  useEffect(() => {
    initColunmsFn()
    getTableListFn(1, 25)
  }, [refreshKey])

  return (
    <div>
      <CustomTableExtend
        columns={columns}
        setColumns={setColumns}
        initColumns={initColumns}
        refreshKey={refreshKey}
        setRefreshKey={setRefreshKey}
        noShowList={[!commonFn.btnAuthorityFlag('ApprovalDownload') && 'download']}
      >
      </CustomTableExtend>

      <CustomTable 
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        rowKey="vendorPaymentId"
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
      />
    </div>
  );
});
export default MainTable;
